<template>
  <div class="h-[1px] my-1 min-h-[1px] w-full bg-black/20 text-black/20" />
</template>
